// Bilingual UI strings for critical pages: Home, Products, Cart, Checkout, WhatsApp FAB.
// Page-level static content (About / Shipping / Terms) remains in its own page files (English).
export const messages = {
  en: {
    // ── Top utility bar ──────────────
    "util.tagline": "Precision Peptides. Superior Results.",
    "util.tagline.short": "Supreme Labs",
    "util.research_only": "Research Use Only · Not for Human Consumption",
    "util.verify_product": "Verify Product",
    "util.my_account": "My Account",
    "util.cart": "Cart",
    "nav.back_home": "Back to Home",

    // ── Main nav ─────────────────────
    "nav.home": "Home",
    "nav.products": "Products",
    "nav.research": "Research",
    "nav.quality": "Quality",
    "nav.about": "About Us",
    "nav.contact": "Contact",

    // ── Hero ─────────────────────────
    "hero.title_1": "PRECISION",
    "hero.title_2": "PEPTIDE",
    "hero.title_3": "RESEARCH",
    "hero.sub": "Engineered for Excellence.",
    "hero.body": "Supreme Laboratories is dedicated to delivering the highest purity research peptides for advanced research and development.",
    "hero.search_placeholder": "Search peptides...",
    "hero.search_btn": "Search",
    "hero.pens_label": "PENS & SPRAYS",
    "hero.vials_label": "VIALS",
    "hero.made_in_germany": "Made in Germany",
    "hero.made_in_germany_sub": "Engineered with German Precision",
    "hero.feat.hplc": "HPLC TESTED",
    "hero.feat.hplc_sub": "≥ 99% PURITY",
    "hero.feat.third": "THIRD-PARTY",
    "hero.feat.third_sub": "LAB VERIFIED",
    "hero.feat.cold": "COLD CHAIN",
    "hero.feat.cold_sub": "SHIPPED",
    "hero.feat.anti": "ANTI-COUNTERFEIT",
    "hero.feat.anti_sub": "VERIFICATION",

    // ── Categories ───────────────────
    "cats.eyebrow": "Catalog",
    "cats.title": "RESEARCH CATEGORIES",
    "cats.view_all": "View All Products",

    // ── Stats / Quality ──────────────
    "quality.eyebrow": "Quality Standards",
    "quality.title_1": "BUILT ON SCIENCE.",
    "quality.title_2": "DRIVEN BY QUALITY.",
    "quality.body": "Our peptides are manufactured in state-of-the-art facilities under strict quality control standards. Every batch is rigorously tested to ensure purity, potency, and consistency.",
    "stats.purity": "PURITY",
    "stats.researchers": "RESEARCHERS TRUST US",
    "stats.peptides": "PEPTIDES AVAILABLE",
    "stats.research_grade": "RESEARCH GRADE",

    // ── Shipping features bar ───────
    "ship.discreet": "DISCREET PACKAGING",
    "ship.discreet_sub": "100% Private & Secure",
    "ship.worldwide": "WORLDWIDE SHIPPING",
    "ship.worldwide_sub": "Fast & Reliable Delivery",
    "ship.research_only": "RESEARCH ONLY",
    "ship.research_only_sub": "Not for Human Use",
    "ship.support": "DEDICATED SUPPORT",
    "ship.support_sub": "Here to Help You",

    // ── Disclaimer ───────────────────
    "disclaimer.title": "Research Use Only",
    "disclaimer.body_a": "All Supreme Laboratories peptides are intended",
    "disclaimer.body_b": "strictly for in-vitro laboratory research",
    "disclaimer.body_c": "Not for human consumption.",

    // ── Footer ───────────────────────
    "footer.research": "Research",
    "footer.research.catalog": "Catalog",
    "footer.research.peptides": "Peptides",
    "footer.research.pens": "Pens & Sprays",
    "footer.research.quality": "Quality Assurance",
    "footer.research.about": "About Us",
    "footer.account": "My Account",
    "footer.account.account": "My Account",
    "footer.account.shipping": "Shipping & Returns",
    "footer.account.terms": "Terms & Conditions",
    "footer.account.privacy": "Privacy Policy",
    "footer.account.contact": "Contact Us",
    "footer.contact": "Contact Us",
    "footer.contact.note": "We typically reply within 24 hours on business days. For order inquiries, please include your order ID.",
    "footer.follow": "Follow Us",
    "footer.follow.note": "Stay connected for product launches and lab updates.",
    "footer.copyright": "© {year} Supreme Laboratories. All rights reserved.",
    "footer.disclaimer": "For research purposes only. Not for human consumption.",

    // ── Products page ────────────────
    "prod.header_search_placeholder": "Search peptides, tags, descriptions...",
    "prod.eyebrow_category": "Category",
    "prod.eyebrow_catalog": "Catalog",
    "prod.title_explore": "EXPLORE PRODUCTS",
    "prod.title_vials": "VIALS",
    "prod.subtitle_vials": "Lyophilized Research Peptide Vials",
    "prod.subtitle_default": "Browse our full lineup of {count} research-grade peptide compounds. Filter by category or search by name, tag, or description.",
    "prod.products_available": "products available.",
    "prod.pens_cta_pre": "Need a custom Pen with alternative dosages?",
    "prod.pens_cta_link": "Contact us",
    "prod.research_only": "Research Use Only",
    "prod.research_only_sub": "Not for human consumption.",
    "prod.filter_eyebrow": "Filter by Category",
    "prod.full_catalog": "Full Catalog",
    "prod.all_peptides": "All Peptides",
    "prod.show_all": "Show All",
    "prod.no_results": "No peptides match your search.",
    "prod.search_results_for": "Results for",
    "prod.search_found": "found",
    "prod.search_clear": "Clear search",
    "prod.add_to_cart": "Add to Cart",
    "prod.view": "View",
    "prod.added_to_cart": "Added to cart",

    // ── Cart page ────────────────────
    "cart.back": "Continue shopping",
    "cart.eyebrow": "Your Cart",
    "cart.empty_title": "Empty",
    "cart.items": "items",
    "cart.item": "item",
    "cart.clear": "Clear cart",
    "cart.empty_card_title": "Your cart is empty",
    "cart.empty_card_body": "Browse the catalog and add peptides to your cart.",
    "cart.browse_catalog": "Browse Catalog",
    "cart.summary": "Summary",
    "cart.summary_items": "Items",
    "cart.summary_subtotal": "Subtotal",
    "cart.summary_shipping": "Shipping",
    "cart.summary_shipping_value": "Calculated at confirmation",
    "cart.summary_total": "Total",
    "cart.place_order": "Place Order",
    "cart.next_step_note": "You will be asked for shipping details in the next step. Payment is confirmed manually by our team.",

    // ── Order modal / checkout ──────
    "co.eyebrow": "Place Order",
    "co.title_new": "New Order",
    "co.title_checkout": "{n} item · Checkout",
    "co.title_checkout_plural": "{n} items · Checkout",
    "co.intro": "Fill in your details below. Our team will contact you shortly to confirm.",
    "co.items_total": "Total",
    "co.first_name": "First Name *",
    "co.last_name": "Last Name *",
    "co.street": "Street *",
    "co.house_number": "No. *",
    "co.address_2": "Apartment / Building (optional)",
    "co.postal_code": "Postal Code *",
    "co.city": "City *",
    "co.region": "Region / State",
    "co.country": "Country *",
    "co.phone": "Phone *",
    "co.email": "Email *",
    "co.notes": "Notes (optional)",
    "co.secure_note": "Your information is encrypted and used solely to process this order.",
    "co.submit": "Submit Order",
    "co.submitting": "Sending...",
    "co.success_title": "Order received",
    "co.success_body": "Thank you. We have received your order and will contact you shortly at the email and phone you provided.",
    "co.close": "Close",
    "co.err_required": "Please fill in all required fields",
    "co.err_generic": "Could not submit your order. Please try again.",
    "co.success_toast": "Order submitted successfully",

    // ── WhatsApp ─────────────────────
    "wa.label": "WhatsApp",
    "wa.msg": "Hi Supreme Laboratories, I'd like to ask about your products.",
  },
};
